import React from 'react';
import {
  CardContentWrapper,
  CardWrapper,
  NoResultsHeader,
  NoResultsWrapper,
  VehicleData,
  ViewAllResults,
} from './SidewideSearch.styles';
import { Card, Headline, Icon, Text } from '@oneaudi/unified-web-components';
import { HOST_NAME } from '../../constants';

interface NoResultsProps {
  isError?: boolean;
}

const NoResults: React.FC<NoResultsProps> = ({ isError }) => {
  const title = isError
    ? 'Results couldn’t be loaded due to a technical error.'
    : 'No matches available at this time.';
  const description = isError
    ? 'Try again, or browse all available options on our vehicle listing pages.'
    : 'Please browse all available options on our vehicle listing pages.';

  const newVlpUrl = `${HOST_NAME}/en/inventory/new/`;
  const usedVlpUrl = `${HOST_NAME}/en/inventory/used/#type=used&availableInMonths=0&usedInventoryType=has-warranties.combined`;
  const cpoVlpUrl = `${HOST_NAME}/en/inventory/used/#type=used&availableInMonths=0&usedInventoryType=has-warranties.yes`;
  return (
    <NoResultsWrapper>
      <NoResultsHeader>
        <Headline
          tag="h3"
          variant={{
            order: '3',
            type: 'headline',
            weight: 'normal',
          }}
        >
          {title}
        </Headline>
        <Text>{description}</Text>
      </NoResultsHeader>

      <CardWrapper tabIndex={0} href={newVlpUrl} vlpCard>
        <Card margin={[0, 0, 0, 0]}>
          <CardContentWrapper>
            <Icon name="traffic" size="l" />
            <VehicleData gap={4}>
              <Text>New Vehicle</Text>
              <ViewAllResults>
                <Text>View inventory</Text>
                <Icon name="forward" size="s" />
              </ViewAllResults>
            </VehicleData>
          </CardContentWrapper>
        </Card>
      </CardWrapper>
      <CardWrapper tabIndex={0} href={usedVlpUrl} vlpCard>
        <Card margin={[0, 0, 0, 0]}>
          <CardContentWrapper>
            <Icon name="traffic" size="l" />
            <VehicleData gap={4}>
              <Text>Pre-owned vehicle</Text>
              <ViewAllResults>
                <Text>View inventory</Text>
                <Icon name="forward" size="s" />
              </ViewAllResults>
            </VehicleData>
          </CardContentWrapper>
        </Card>
      </CardWrapper>
      <CardWrapper tabIndex={0} href={cpoVlpUrl} vlpCard>
        <Card margin={[0, 0, 0, 0]}>
          <CardContentWrapper>
            <Icon name="traffic" size="l" />
            <VehicleData gap={4}>
              <Text>Certified vehicle</Text>
              <ViewAllResults>
                <Text>View inventory</Text>
                <Icon name="forward" size="s" />
              </ViewAllResults>
            </VehicleData>
          </CardContentWrapper>
        </Card>
      </CardWrapper>
    </NoResultsWrapper>
  );
};

export default NoResults;
